import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import classnames from 'classnames';
import { Button } from 'Shared/components';
import { NavigationButtonIcon } from './components/NavigationButtonIcon/NavigationButtonIcon';
import { EIconType } from './consts';
import styles from './NavigationButton.css';
const NavigationButton = ({ id, enable = false, onClick = () => { }, className, text, testId, children, infoIconText, }) => {
    const iconType = enable ? EIconType.Enabled : EIconType.Disabled;
    const buttonClassName = classnames(styles.button, {
        [styles.disabled]: !enable,
    });
    const layoutClassName = classnames(styles.layout, className);
    const infoIconTitle = (_jsx("span", { children: infoIconText }, void 0));
    return (_jsx("div", Object.assign({ className: layoutClassName }, { children: _jsxs(Button, Object.assign({ testId: testId, className: buttonClassName, onClick: onClick }, { children: [text, children, _jsx(NavigationButtonIcon, { id: id, iconType: iconType, title: infoIconTitle }, void 0)] }), void 0) }), void 0));
};
export default memo(NavigationButton);
